import { render, staticRenderFns } from "./RecruitmentTypeManagement.vue?vue&type=template&id=0ececb8c&scoped=true"
import script from "./RecruitmentTypeManagement.vue?vue&type=script&lang=js"
export * from "./RecruitmentTypeManagement.vue?vue&type=script&lang=js"
import style0 from "./RecruitmentTypeManagement.vue?vue&type=style&index=0&id=0ececb8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ececb8c",
  null
  
)

export default component.exports